import request from '@/utils/request'

// 查询
export function fetchList(data) {
  return request.post('/tbBaseMaterialContractExec/page', data, {
    trim: true
  })
}

// 创建
export function create(data) {
  return request.post('/tbBaseMaterialContractExec/create', data)
}

// 修改
export function updateById(data) {
  return request.post('/tbBaseMaterialContractExec/updateById', data)
}

// 删除
export function deleteById(id) {
  return request.get(`/tbBaseMaterialContractExec/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch(ids) {
  return request.get('/tbBaseMaterialContractExec/delete/batch', {
    params: {
      ids
    }
  })
}

// 打印
export function printApi(data) {
  return request.post('/tbBaseMaterialContractExec/print', data)
}

// 是否打印成功
export function isPrintSuccessApi(data) {
  return request.post('/tbBaseMaterialContractExec/printRollBack', data)
}

export function getParentDept() {
  return request.get('/dataView/getParentDept')
}

// 验证打印是否合法
export function isLegalPrintApi(data) {
  return request.post('/print/info/check', data)
}

// 物料编码数据查询
export function longRangeSearchApi(data) {
  return request.post('/unit/conversion/getList', data)
}
// 搜索历史记录查询
export function searchHistoryApi(data) {
  return request.post('/search/history/getSearchHistory', data)
}
// 添加历史记录
export function addHistoryApi(data) {
  return request.post('/search/history/addToSearchHistory', data)
}
// 删除单个历史记录
export function delHistoryApi(data) {
  return request.post('/search/history/deleteFromSearchHistory', data)
}
// 清空历史记录
export function clearHistoryApi(data) {
  return request.post('/search/history/clearSearchHistory', data)
}

// 搜索历史记录查询2
export function searchHistoryApi_PC(data) {
  return request.post('/search/history/pc/getSearchHistoryPC', data)
}
// 添加历史记录2
export function addHistoryApi_PC(data) {
  return request.post('/search/history/pc/addToSearchHistoryPC', data)
}
// 删除单个历史记录2
export function delHistoryApi_PC(data) {
  return request.post('/search/history/pc/deleteFromSearchHistoryPC', data)
}
// 清空历史记录2
export function clearHistoryApi_PC(data) {
  return request.post('/search/history/pc/clearSearchHistoryPC', data)
}


// 获取打印机模板列表对照数据
export function getListFiledApi(data) {
  return request.post('/printer/template/getTemplateFieldListByTemplateKey', data)
}